import { render, staticRenderFns } from "./ContextMenuComponent.vue?vue&type=template&id=3f4a0c58&scoped=true&"
import script from "./ContextMenuComponent.vue?vue&type=script&lang=js&"
export * from "./ContextMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenuComponent.vue?vue&type=style&index=0&id=3f4a0c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a0c58",
  null
  
)

export default component.exports